"use client";
import {
  findExecutor,
  findExecutors,
  mergeExecutors
} from "./chunk-LGLUH4PH.js";

// src/client.tsx
import {
  createContext,
  useContext,
  useEffect,
  useState
} from "react";
import { Fragment, jsx } from "react/jsx-runtime";
var ExecutorsContext = createContext({
  executors: []
});
var OperationExecutorsProvider = ({
  children,
  executors
}) => {
  const upstream = useContext(ExecutorsContext).executors;
  const merged = mergeExecutors(upstream, executors);
  return /* @__PURE__ */ jsx(
    ExecutorsContext.Provider,
    {
      value: {
        executors: merged
      },
      children
    }
  );
};
var useOperationExecutor = (id, variables) => {
  const { executors } = useContext(ExecutorsContext);
  return findExecutor(executors, id, variables);
};
var useAllOperationExecutors = (id, variables) => {
  const { executors } = useContext(ExecutorsContext);
  return findExecutors(executors, id, variables);
};
function DelayedOperation({
  children,
  operation
}) {
  const [state, setState] = useState("loading");
  const [data, setData] = useState(void 0);
  const [error, setError] = useState();
  useEffect(() => {
    setState("loading");
    operation().then((result) => {
      setData(result);
      setState("success");
      return;
    }).catch((error2) => {
      setError(error2);
      setState("error");
    });
  }, [operation, setData, setError, setState]);
  return /* @__PURE__ */ jsx(Fragment, { children: children({ state, error, data }) });
}
function SingleOperation(props) {
  const registry = useContext(ExecutorsContext).executors;
  const executor = findExecutor(registry, props.id, props.variables);
  if (!(executor instanceof Function)) {
    return props.children({ state: "success", data: executor });
  }
  return /* @__PURE__ */ jsx(
    DelayedOperation,
    {
      ...props,
      operation: () => executor(props.id, props.variables)
    }
  );
}
function MultiOperation(props) {
  const registry = useContext(ExecutorsContext).executors;
  const executors = findExecutors(registry, props.id, props.variables);
  if (executors.every((exec) => !(exec instanceof Function))) {
    return props.children({ state: "success", data: executors });
  }
  return /* @__PURE__ */ jsx(
    DelayedOperation,
    {
      ...props,
      operation: () => Promise.all(
        executors.map(
          (exec) => exec instanceof Function ? exec(props.id, props.variables) : exec
        )
      )
    }
  );
}
var Operation = ({
  all,
  ...props
}) => {
  return all ? /* @__PURE__ */ jsx(MultiOperation, { ...props }) : /* @__PURE__ */ jsx(SingleOperation, { ...props });
};
export {
  Operation,
  OperationExecutorsProvider,
  findExecutor,
  findExecutors,
  useAllOperationExecutors,
  useOperationExecutor
};
